var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"box"},[_c('p',[_vm._v(_vm._s(_vm.message.date))]),_c('p',[_vm._v(_vm._s(_vm.message.name))]),_c('p',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.message.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }